/**
 * Scrollable BAA text with DRAFT watermark (counsel review). Content is plain text / pre-wrap.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

const ProviderCmrBaaViewer = ({ text, maxHeight = 380 }) => {
  if (!text) return null;

  return (
    <Box
      sx={{
        position: 'relative',
        maxHeight,
        overflow: 'auto',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pointerEvents: 'none',
          overflow: 'hidden',
        }}
        aria-hidden
      >
        <Typography
          component="span"
          sx={{
            transform: 'rotate(-32deg)',
            fontSize: { xs: '2.75rem', sm: '3.5rem' },
            fontWeight: 800,
            color: 'text.secondary',
            opacity: 0.11,
            userSelect: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          DRAFT
        </Typography>
      </Box>
      <Box sx={{ position: 'relative', zIndex: 1, p: 2 }}>
        <Typography
          component="pre"
          sx={{
            m: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontFamily: 'inherit',
            fontSize: '0.8125rem',
            lineHeight: 1.5,
            color: 'text.primary',
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProviderCmrBaaViewer;
